<div class="text-center">
    <p>Powered by <strong class="">VIVIPOST</strong > {{version}}</p>
</div>